import React, { useEffect, useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

function ProductLiNav({ product }) {
    const [newTitle, setNewTitle] = useState("");
    const { title } = product;
  
    const changeUrl = (title) => {
      const newTitulo = title.replace(/[\s-]+/g, "-").toLowerCase();
      setNewTitle(newTitulo);
    };
  
    useEffect(() => {
      changeUrl(title);
    }, []);

  return (
    <li className="col-12 col-lg-12 col-md-12 col-sm-6 ">
      <a className="productTitle" href={product.type === 'productoLinea' ? `/producto/${newTitle}` : `/producto-especial/${newTitle}`}>
        <img
          alt=""
          src={product.imageIcon ? product.imageIcon[0]?.url : ""}
          id="imagen"
        />
        {product.title} <ArrowForwardIcon />
      </a>
    </li>
  );
}

export default ProductLiNav;
